import styles from './TermsOfService.module.scss';
import {Link} from "react-router-dom";

export const PrivacyPolicy = () => {
    return (
        <div className={styles['services-container']}>
            <div className={styles['black-bg']}>
                <div className={styles['bottom-row']}>
                    <div className={styles['card5']}>
                        <div className={styles['title']}>
                            <p>Effective Date: November 1, 2024</p>
                            <p>Privacy Policy</p>
                        </div>
                        <p>Stamey-White Law (“we,” “our,” or “us”) is committed to protecting the privacy and security
                            of your personal information. This Privacy Policy explains how we collect, use, disclose,
                            and protect your information when you visit our website, use our services, or otherwise
                            interact with us.</p>
                        <div className={styles['frames-tos']}>
                            <p>1. Information We Collect</p>
                            <h6>We may collect personal and non-personal information from you in the following
                                ways:</h6>
                            <h6>a. Personal Information You Provide</h6>
                            <ul>
                                <li>Contact Information: Name, email address, phone number, and mailing address.</li>
                                <li>Case Details: Information related to your legal matter, including documents and
                                    communications.
                                </li>
                                <li>Payment Information: Billing details and payment methods when applicable.</li>
                            </ul>
                            <h6>b. Automatically Collected Information</h6>
                            <h6>When you visit our website, we may collect certain information automatically:</h6>
                            <ul>
                                <li>IP address</li>
                                <li>Browser type</li>
                                <li>Device information</li>
                                <li>Pages visited and the duration of your visit</li>
                                <li>Cookies and similar technologies</li>
                            </ul>
                            <h6>c. Third-Party Information</h6>
                            <h6>We may receive information about you from third-party sources, such as referrals or
                                public records, as part of providing our services.</h6>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>2. How We Use Your Information</p>
                            <p>We use your information to:</p>
                            <ul>
                                <li>Provide and improve our legal services.</li>
                                <li>Respond to inquiries and communicate with you.</li>
                                <li>Process payments and manage billing.</li>
                                <li>Ensure compliance with legal and regulatory obligations.</li>
                                <li>Maintain and improve our website functionality and user experience.</li>
                                <li>Market our services, where permitted by law.</li>
                            </ul>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>3. Disclosure of Information</p>
                            <p>We do not sell your personal information. However, we may share your information in the
                                following circumstances:</p>
                            <ul>
                                <li>With Your Consent: When you have provided explicit permission.</li>
                                <li>Legal Compliance: To comply with legal obligations, court orders, or government
                                    requests.
                                </li>
                                <li>Service Providers: With third parties who assist in delivering our services,
                                    such as IT support, payment processors, or marketing consultants, bound by
                                    confidentiality agreements.
                                </li>
                                <li>Business Transactions: In the event of a merger, acquisition, or sale of
                                    assets, your information may be transferred as part of the transaction.
                                </li>
                            </ul>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>4. Cookies and Tracking Technologies</p>
                            <p>Our website may use cookies and similar technologies to:</p>
                            <ul>
                                <li>Enhance user experience.</li>
                                <li>Track website analytics and performance.</li>
                            </ul>
                            <h6>You can control cookie preferences through your browser settings.</h6>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>5. Data Security</p>
                            <p>We implement appropriate technical and organizational measures to safeguard your
                                information against unauthorized access, alteration, disclosure, or destruction.
                                However, no data transmission or storage can be guaranteed as 100% secure.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>6. Your Rights and Choices</p>
                            <p>Depending on your jurisdiction, you may have the following rights regarding your personal
                                information:</p>
                            <ul>
                                <li>Access and review the data we hold about you.</li>
                                <li>Request corrections or updates to your information.</li>
                                <li>Request deletion of your data, subject to legal or contractual obligations.</li>
                                <li>Restrict or object to certain data processing activities.</li>
                                <li>Withdraw consent for marketing communications.</li>
                            </ul>
                            <h6>To exercise these rights, contact us at <Link to="/contact">here</Link>.</h6>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>7. Third-Party Links</p>
                            <p>Our website may include links to third-party websites. We are not responsible for the
                                privacy practices or content of those websites. Please review their privacy
                                policies.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>8. Children’s Privacy</p>
                            <p>Our services are not intended for individuals under the age of 18, and we do not
                                knowingly collect personal information from minors.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>9. Updates to This Policy</p>
                            <p>We may update this Privacy Policy periodically to reflect changes in our practices or
                                legal requirements. The updated version will be posted on our website with a revised
                                “Effective Date.”</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>12. Contact Information</p>
                            <p>For questions or concerns about these Terms, please contact us:
                                Stamey-White, APC
                                2903 Noriega St 43 San Francisco, CA 94122
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};